module.exports = __webpack_public_path__ + "static/media/co_hotel_icon_2.931af18e.svg";